import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _selfServePageToStepA, _selfServePageToStepA2, _routeToStepPage, _stepPageToNodeLevelA;
import { persistUrlParams } from "@faire/help-center-utils/lib/persistUrlParams";
import { route as selfServeRoute } from "@faire/web-api--source/routes/www/support/self-serve";
import { route as selfServeChatRoute } from "@faire/web-api--source/routes/www/support/self-serve/chat";
import { route as supportSelfServeChatCsat } from "@faire/web-api--source/routes/www/support/self-serve/chat-csat";
import { route as selfServeEmailRoute } from "@faire/web-api--source/routes/www/support/self-serve/email";
import { route as selfServeIssueSearchRoute } from "@faire/web-api--source/routes/www/support/self-serve/issue-search";
import { route as selfServeIssueSelectRoute } from "@faire/web-api--source/routes/www/support/self-serve/issue-select";
import { route as selfServeOrderSelectRoute } from "@faire/web-api--source/routes/www/support/self-serve/order-select";
import { route as selfServePhoneRoute } from "@faire/web-api--source/routes/www/support/self-serve/phone";
import { route as selfServePhoneSubmissionConfirmationRoute } from "@faire/web-api--source/routes/www/support/self-serve/phone-submission-confirmation";
import { route as selfServeRecommendedArticleRoute } from "@faire/web-api--source/routes/www/support/self-serve/recommended-article";
import { route as selfServeEmailSubmissionConfirmationRoute } from "@faire/web-api--source/routes/www/support/self-serve/submission-confirmation";
import { route as selfServeTopicsRoute } from "@faire/web-api--source/routes/www/support/self-serve/topics";
var paramsNeedToBeDeleted = ["brand_order_token", "l1", "l2", "l3", "l4", "l5", "faire_direct_widget_chat"];
export var StepPage;
(function (StepPage) {
  StepPage["TOPIC_SELECTION"] = "TOPIC_SELECTION";
  StepPage["ORDER_SELECTION"] = "ORDER_SELECTION";
  StepPage["TELL_US_MORE"] = "TELL_US_MORE";
  StepPage["ANSWER"] = "ANSWER";
  StepPage["EMAIL_FORM"] = "EMAIL_FORM";
  StepPage["PHONE_FORM"] = "PHONE_FORM";
  StepPage["EMAIL_SUBMISSION_CONFIRMATION"] = "EMAIL_SUBMISSION_CONFIRMATION";
  StepPage["PHONE_SUBMISSION_CONFIRMATION"] = "PHONE_SUBMISSION_CONFIRMATION";
  StepPage["CHAT"] = "CHAT";
  StepPage["ISSUE_SEARCH"] = "ISSUE_SEARCH";
  StepPage["CHAT_CSAT"] = "CHAT_CSAT";
})(StepPage || (StepPage = {}));
export var TOTAL_4_STEPS = 4;
export var TOTAL_3_STEPS = 3;
export var selfServePageToStepAndRouteWithoutOrderSelection = (_selfServePageToStepA = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_selfServePageToStepA, StepPage.TOPIC_SELECTION, {
  step: 1,
  route: persistUrlParams(selfServeTopicsRoute, paramsNeedToBeDeleted)
}), StepPage.ISSUE_SEARCH, {
  step: 1,
  route: persistUrlParams(selfServeIssueSearchRoute, paramsNeedToBeDeleted)
}), StepPage.TELL_US_MORE, {
  step: 2,
  route: persistUrlParams(selfServeIssueSelectRoute, paramsNeedToBeDeleted)
}), StepPage.ANSWER, {
  step: 3,
  route: persistUrlParams(selfServeRecommendedArticleRoute, paramsNeedToBeDeleted)
}), StepPage.EMAIL_FORM, {
  step: 3,
  route: persistUrlParams(selfServeEmailRoute, paramsNeedToBeDeleted)
}), StepPage.PHONE_FORM, {
  step: 3,
  route: persistUrlParams(selfServePhoneRoute, paramsNeedToBeDeleted)
}), StepPage.EMAIL_SUBMISSION_CONFIRMATION, {
  step: 3,
  route: persistUrlParams(selfServeEmailSubmissionConfirmationRoute, paramsNeedToBeDeleted)
}), StepPage.PHONE_SUBMISSION_CONFIRMATION, {
  step: 3,
  route: persistUrlParams(selfServePhoneSubmissionConfirmationRoute, paramsNeedToBeDeleted)
}), StepPage.CHAT, {
  step: 3,
  route: persistUrlParams(selfServeChatRoute, paramsNeedToBeDeleted)
}), StepPage.CHAT_CSAT, {
  step: 4,
  route: persistUrlParams(selfServeChatRoute, paramsNeedToBeDeleted)
}), _defineProperty(_selfServePageToStepA, StepPage.ORDER_SELECTION, {
  step: 0,
  route: ""
}));
export var selfServePageToStepAndRoute = (_selfServePageToStepA2 = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_selfServePageToStepA2, StepPage.TOPIC_SELECTION, {
  step: 1,
  route: persistUrlParams(selfServeTopicsRoute, paramsNeedToBeDeleted)
}), StepPage.ISSUE_SEARCH, {
  step: 1,
  route: persistUrlParams(selfServeIssueSearchRoute, paramsNeedToBeDeleted)
}), StepPage.ORDER_SELECTION, {
  step: 2,
  route: persistUrlParams(selfServeOrderSelectRoute, paramsNeedToBeDeleted)
}), StepPage.TELL_US_MORE, {
  step: 3,
  route: persistUrlParams(selfServeIssueSelectRoute, paramsNeedToBeDeleted)
}), StepPage.ANSWER, {
  step: 4,
  route: persistUrlParams(selfServeRecommendedArticleRoute, paramsNeedToBeDeleted)
}), StepPage.EMAIL_FORM, {
  step: 4,
  route: persistUrlParams(selfServeEmailRoute, paramsNeedToBeDeleted)
}), StepPage.PHONE_FORM, {
  step: 4,
  route: persistUrlParams(selfServePhoneRoute, paramsNeedToBeDeleted)
}), StepPage.EMAIL_SUBMISSION_CONFIRMATION, {
  step: 4,
  route: persistUrlParams(selfServeEmailSubmissionConfirmationRoute, paramsNeedToBeDeleted)
}), StepPage.PHONE_SUBMISSION_CONFIRMATION, {
  step: 4,
  route: persistUrlParams(selfServePhoneSubmissionConfirmationRoute, paramsNeedToBeDeleted)
}), StepPage.CHAT, {
  step: 4,
  route: persistUrlParams(selfServeChatRoute, paramsNeedToBeDeleted)
}), _defineProperty(_selfServePageToStepA2, StepPage.CHAT_CSAT, {
  step: 4,
  route: persistUrlParams(selfServeChatRoute, paramsNeedToBeDeleted)
}));
export var routeToStepPage = (_routeToStepPage = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_routeToStepPage, selfServeTopicsRoute, StepPage.TOPIC_SELECTION), selfServeRoute, StepPage.TOPIC_SELECTION), selfServeIssueSearchRoute, StepPage.ISSUE_SEARCH), selfServeOrderSelectRoute, StepPage.ORDER_SELECTION), selfServeIssueSelectRoute, StepPage.TELL_US_MORE), selfServeRecommendedArticleRoute, StepPage.ANSWER), selfServeEmailRoute, StepPage.EMAIL_FORM), selfServePhoneRoute, StepPage.PHONE_FORM), selfServeEmailSubmissionConfirmationRoute, StepPage.EMAIL_SUBMISSION_CONFIRMATION), selfServePhoneSubmissionConfirmationRoute, StepPage.PHONE_SUBMISSION_CONFIRMATION), _defineProperty(_defineProperty(_routeToStepPage, selfServeChatRoute, StepPage.CHAT), supportSelfServeChatCsat, StepPage.CHAT_CSAT));
/**
 * This is a mapping of the step page to the node level that needs to be cleaned.
 * For example: if the user is on the answer page, all the level 5 nodes above need to be cleaned,
 * Which we keep Level 1-4 nodes in the selfServeContextStore
 */
export var stepPageToNodeLevelAboveThatNeedsToBeCleaned = (_stepPageToNodeLevelA = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_stepPageToNodeLevelA, StepPage.TOPIC_SELECTION, 2), StepPage.ISSUE_SEARCH, 5), StepPage.ORDER_SELECTION, 2), StepPage.TELL_US_MORE, 5), StepPage.ANSWER, 5), StepPage.EMAIL_FORM, 5), StepPage.PHONE_FORM, 5), StepPage.EMAIL_SUBMISSION_CONFIRMATION, 5), StepPage.PHONE_SUBMISSION_CONFIRMATION, 5), StepPage.CHAT, 5), _defineProperty(_stepPageToNodeLevelA, StepPage.CHAT_CSAT, 5));